import React, { useEffect } from 'react';

import { AccountFacilities, FacilitiesList } from './components';
import { useAppDispatch, useAppSelector } from 'hooks';
import { facilityActions } from 'utils/store';

import styles from './styles.module.sass';
import { DataStatus } from 'types/enums';
import { Loader } from 'components';
import { Box } from '@mui/material';

export const ConnectFacilityScreen = () => {
  const isLoading = useAppSelector(({ facility }) => facility.status === DataStatus.LOADING);
  const dispatch = useAppDispatch();
  const userId = useAppSelector(({ user }) => user.data?.id);
  useEffect(() => {
    if (userId) {
      dispatch(facilityActions.getFacilityByUserId(userId));
    }
  }, [dispatch, userId]);

  useEffect(() => {
    dispatch(facilityActions.getAllFacilities());
  }, [dispatch]);

  return (
    <>
      <Loader isVisible={isLoading} isOverlay />
      <Box className={styles.container}>
        <AccountFacilities />
        <FacilitiesList />
      </Box>
    </>
  );
};
